import PropTypes from 'prop-types';
import React from 'react';

export default class SearchForm extends React.Component {
    static displayName = 'SearchForm';

    static propTypes = {
        queryText: PropTypes.string.isRequired,
        content: PropTypes.shape({
            id: PropTypes.number.isRequired,
            title: PropTypes.isRequired,
        }),
        onSearch: PropTypes.func.isRequired,
        stealFocus: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            queryText: props.queryText,
            context: props.content != null ? String(props.content.id) : null,
        };
    }

    onContextChanged = e => {
        let { value } = e.target;
        if (value.length == 0) {
            value = null;
        }

        this.setState({
            context: value,
        });
    };

    onFocusRef = searchInput => {
        if (searchInput && this.props.stealFocus) {
            searchInput.focus();
        }
    };

    onSubmit = e => {
        e.preventDefault();

        const { onSearch } = this.props;
        const { queryText, context } = this.state;

        onSearch(queryText, context);
    };

    onTextChanged = e => {
        this.setState({
            queryText: e.target.value,
        });
    };

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            queryText: props.queryText,
            context: props.content != null ? String(props.content.id) : null,
        });
    }

    render() {
        const { content } = this.props;

        let scopeSelector;
        if (content != null) {
            scopeSelector = (
                <ul>
                    <li>
                        <input
                            checked={this.state.context != null}
                            id="search-only-radio-button"
                            name="context"
                            onChange={this.onContextChanged}
                            type="radio"
                            value={content.id}
                        />
                        <label htmlFor="search-only-radio-button">
                            Search only <span>{content.title}</span>
                        </label>
                    </li>
                    <li>
                        <input
                            id="search-all-radio-button"
                            name="context"
                            onChange={this.onContextChanged}
                            type="radio"
                            value=""
                        />
                        <label htmlFor="search-all-radio-button">
                            Search all materials
                        </label>
                    </li>
                </ul>
            );
        }

        const searchDisabled =
            this.state.queryText === '' ||
            (this.props.queryText == this.state.queryText &&
                Boolean(this.state.context) === Boolean(this.props.content));

        return (
            <form onSubmit={this.onSubmit}>
                <input
                    id="search-query-input"
                    type="text"
                    name="queryText"
                    value={this.state.queryText}
                    onChange={this.onTextChanged}
                    ref={this.onFocusRef}
                />
                <label htmlFor="search-query-input" className="aural">
                    Search term
                </label>
                {scopeSelector}
                <input type="submit" value="Search" disabled={searchDisabled} />
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/search_form.ui.jsx